export default "__VITE_ASSET__ClgO_pPK__"